module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm5"
    }
  }, [_c('p', {
    staticClass: "dedi"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("For my mother, whose beloved stories of a late Victorian childhood made those years very real for me.")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And for Viola, Ernestine, and Becky, who made suggestions.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-413b291e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/For_my_mother.vue
// module id = 66
// module chunks = 0